import React, { useEffect, useState } from "react";
import { errorMessagesData } from "../../data/stripeErrors";

import {
  CardElement,
  useStripe,
  useElements,
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from "@stripe/react-stripe-js";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Card,
  Alert,
} from "react-bootstrap";
import { updatePaymentStatus } from "@/api/bidDepositApiHold";
import "./Bid.css";
import { useSelector } from "react-redux";
import { stateListData } from "@/api/bid";
import { ShimmerButton, ShimmerText } from "react-shimmer-effects";
import {
  FaCcAmex,
  FaCcDinersClub,
  FaCcDiscover,
  FaCcJcb,
  FaCcMastercard,
  FaCcVisa,
} from "react-icons/fa";
import { formatMoney } from "@/utils/numCommas";
import { validate } from "uuid";
import { trackApiCall } from "@/utils/analytics";
const BidForm = ({
  setHideContentTwo,
  setShowMessage,
  userInfo,
  secretClientId,
  setShowFailMessage,
  paymentReferenceNumber,
  formatedChargeAmount,
  formatedAmount,
  errorCardMsg,
  setErrorCardMsg,
  paymentFlag,
  WinningEmail,
  setWinningEmail,
  listingId,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: userInfo?.email || "",
    phone: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    cardNumber: "",
  });
  const [cardErrors, setCardErrors] = useState({
    cardNumber: "",
    cardExpiry: "",
    cardCvc: "",
  });
  const [invalidCreditCard, setInvalidCreditCard] = useState("");
  // Add to your existing state declarations
  const [validationErrors, setValidationErrors] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    address1: "",
    city: "",
    state: "",
    zip: "",
    cardNumber: "",
  });

  const [cardBrand, setCardBrand] = useState(null);

  // Add validation rules
  const validationRules = {
    firstName: (value) => {
      if (!value.trim()) return "This field is required";
      const allowedCharsRegex = /^[a-zA-Z0-9\-._' ]*$/;
      if (value && !allowedCharsRegex.test(value)) {
        return "Characters allowed: a-z A-Z 0-9 and - . ' _";
      }
      return "";
    },
    lastName: (value) => {
      if (!value.trim()) return "This field is required";
      const allowedCharsRegex = /^[a-zA-Z0-9\-._' ]*$/;
      if (value && !allowedCharsRegex.test(value)) {
        return "Characters allowed: a-z A-Z 0-9 and - . ' _";
      }
      return "";
    },
    phone: (value) => {
      if (!value) return "This field is required";
      if (!/^\d{10}$/.test(value)) return "Please enter a valid phone number";
      return "";
    },
    address1: (value) => {
      if (!value.trim()) return "This field is required";
      const allowedCharsRegex = /^[A-Za-z0-9\s#]{1,30}$/;
      if (value && !allowedCharsRegex.test(value)) {
        return "Characters allowed: a-z A-Z 0-9 and - . ' _";
      }
      return "";
    },
    city: (value) => {
      if (!value.trim()) return "This field is required";
      const allowedCharsRegex = /^[a-zA-Z0-9\-._' ]*$/;
      if (value && !allowedCharsRegex.test(value)) {
        return "Characters allowed: a-z A-Z 0-9 and - . ' _";
      }
      return "";
    },
    state: (value) => {
      if (!value) return "This field is required";
      return "";
    },
    zip: (value) => {
      if (!value) return "This field is required";
      if (!/^\d{5}$/.test(value))
        return "Please enter a valid 5-digit ZIP code";
      return "";
    },
    cardNumber: (value) => {
      if (!value) return "This field is required";
      return "";
    },
  };
  const [stateList, setStatelist] = useState([]);
  // const [cardBrand, setCardBrand] = useState(null);
  const selector = useSelector((state) => state?.bidwizardStage?.Stage);
  const selectorAmount = useSelector(
    (state) => state?.bidwizardStage.BidAmount
  );
  const { bidRequest, validationResult } = selector || {};
  const selectorFormatedAmount = formatMoney(selectorAmount?.bidDepositAmount);
  const selectorFormatedChargeAmount = formatMoney(
    selectorAmount?.bidDepositChargeAmount
  );
  const TEST_CARDS = {
    VALID: "4242424242424242",
    INSUFFICIENT_FUNDS: "4000000000009995",
    DECLINED: "4000000000000002",
    THREE_D_SECURE: "4000002760003184",
  };
  // Pre-populate form when userInfo changes
  useEffect(() => {
    if (userInfo) {
      setFormData({
        ...formData,
        firstName: userInfo.firstName || "",
        lastName: userInfo.lastName || "",
        email: userInfo.emailId || "",
        phone: userInfo.phoneNumber || "",
        address1: userInfo.address?.address1 || "",
        address2: userInfo.address?.address2 || "",
        city: userInfo.address?.city || "",
        state: userInfo.address?.state || "",
        zip: userInfo.address?.zip || "",
      });
    }
  }, [userInfo]);

  useEffect(() => {
    stateListData().then((res) => {
      setStatelist(res.data);
    });
  }, []);
  // Add handleBlur function
  const handleBlur = (e) => {
    const { id, value } = e.target;
    if (validationRules[id]) {
      const validationError = validationRules[id](value);
      setValidationErrors((prev) => ({
        ...prev,
        [id]: validationError,
      }));
    }
  };
  const handleChange = (e) => {
    const { id, value } = e.target;
    // Check if this is the phone field
    let processedValue = value;
    if (id === "phone" || id === "phoneNumber" || id === "zip") {
      // Remove all alphabet characters
      processedValue = value.replace(/[a-zA-Z]/g, "");
    }
    setFormData((prevData) => ({
      ...prevData,
      [id]: processedValue,
    }));
  };
  // At the top of your component, add this object

  const CARD_BRAND_ICONS = {
    visa: "/assets/svg/card-icons/visa.svg",
    mastercard: "/assets/svg/card-icons/mastercard.svg",
    amex: "/assets/svg/card-icons/amex.svg",
    discover: "/assets/svg/card-icons/discover.svg",
    diners: "/assets/svg/card-icons/diners.svg",
    jcb: "/assets/svg/card-icons/jcb.svg",
  };

  // Add this function
  const getCardBrandIcon = (brand) => {
    const iconPath = CARD_BRAND_ICONS[brand];
    return iconPath ? (
      <img
        src={iconPath}
        alt={`${brand} card`}
        style={{ height: "24px", width: "auto", marginLeft: "10px" }}
      />
    ) : null;
  };

  const getErrorMessage = (errorCode) => {
    // Find the matching object in the array based on the 'name' property
    const trimmedCode = errorCode.trim();
    const errorMapping = errorMessagesData.find(
      (item) =>
        item.name &&
        typeof item.name === "string" &&
        item.name.trim() === trimmedCode
    );
    if (errorMapping && typeof errorMapping.text === "string") {
      return errorMapping.text;
    } else {
      //code wasn't found in the mapping show default
      return "We're experiencing a technical issue while collecting your bid deposit. Please wait for a few minutes and try again. If the issue still persists, please reach out to our customer support team at (855) 882-1314.";
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const cardType = "";

    const form = event.currentTarget;

    if (isLoading) return;

    const cardNumber = elements.getElement(CardNumberElement);
    const cardExpiry = elements.getElement(CardExpiryElement);
    const cardCvc = elements.getElement(CardCvcElement);

    // Reset previous errors
    setError(null);
    setCardErrors({
      cardNumber: "",
      cardExpiry: "",
      cardCvc: "",
    });

    // EARLY STRIPE CARD FIELD VALIDATION
    let hasCardError = false;
    const newCardErrors = {
      cardNumber: "",
      cardExpiry: "",
      cardCvc: "",
    };

    if (!cardNumber || !cardNumber._complete) {
      newCardErrors.cardNumber = "This field is required.";
      hasCardError = true;
    }

    if (!cardExpiry || !cardExpiry._complete) {
      newCardErrors.cardExpiry = "This field is required.";
      hasCardError = true;
    }

    if (!cardCvc || !cardCvc._complete) {
      newCardErrors.cardCvc = "This field is required.";
      hasCardError = true;
    }

    if (hasCardError) {
      setCardErrors(newCardErrors);
      setValidated(true);
      return;
    }

    //   check  form field validity
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    if (!stripe || !elements) {
      setError("Payment processing not available. Please try again.");
      return;
    }

    setIsLoading(true);

    try {
      const { error: intentError, paymentIntent } =
        await stripe.confirmCardPayment(secretClientId, {
          payment_method: {
            type: "card",
            card: cardNumber,
            billing_details: {
              name: `${formData.firstName} ${formData.lastName}`,
              email: formData.email,
              phone: formData.phone,
              address: {
                city: formData.city,
                country: "US",
                line1: formData.address1,
                state: formData.state,
                postal_code: formData.zip,
              },
            },
          },
          setup_future_usage: "off_session",
        });

      if (intentError) {
        let cardType = "";
        let CARD_TYPE_ERROR = null;

        cardType =
          (intentError.code === "card_declined" &&
            intentError.payment_method?.card?.funding) ||
          null;

        if (cardType === "debit") {
          CARD_TYPE_ERROR = "DEBITCARD_NOT_ALLOWED";
        } else if (cardType === "prepaid") {
          CARD_TYPE_ERROR = "PREPAIDCARD_NOT_ALLOWED";
        } else if (cardType === "unknown") {
          CARD_TYPE_ERROR = "UNKNOWNCARD_NOT_ALLOWED";
        }

        setErrorCardMsg({
          status: "ERROR",
          error_code: CARD_TYPE_ERROR || intentError.code,
          orderReferenceNumber: paymentReferenceNumber || "",
          errorMessage: getErrorMessage(CARD_TYPE_ERROR || intentError.code),
        });

        if (
          CARD_TYPE_ERROR === "DEBITCARD_NOT_ALLOWED" ||
          CARD_TYPE_ERROR === "PREPAIDCARD_NOT_ALLOWED" ||
          CARD_TYPE_ERROR === "UNKNOWNCARD_NOT_ALLOWED"
        ) {
          setInvalidCreditCard(
            "Invalid entry. Please use a credit card to complete this transaction."
          );
          return;
        }

        // Fallback: show generic error
        setHideContentTwo(true);
        setShowFailMessage(true);
        return;
      }

      trackApiCall({
        eventName: "bid_deposit_payment_success",
        eventCategory: "Bid Participation Page",
        eventSource: "on payment success",
        eventLabel: `${listingId} | SRC : NewBidWizard | API Status :${paymentIntent.status}`,
      });

      if (paymentIntent.status === "requires_capture") {
        try {
          const statusResponse = await updatePaymentStatus(
            paymentReferenceNumber
          );
          setWinningEmail(statusResponse?.data?.data?.email);
          if (statusResponse.status === 200) {
            const responseData = statusResponse.data; // or however you access the response body

            trackApiCall({
              eventName: "bid_deposit_status_callback",
              eventCategory: "Bid Participation Page",
              eventSource: "on payment success",
              eventLabel: `${listingId} | SRC : NewBidWizard`,
              eventParams: {
                api_status: responseData.status,
                error_code: responseData.errorCode,
              },
            });

            if (responseData.status === "SUCCESS") {
              setShowMessage(true);
              setHideContentTwo(true);
              setInvalidCreditCard("");
            } else if (responseData.status === "FAILURE") {
              // Handle failure cases
              setErrorCardMsg({
                status: "ERROR",
                error_code: responseData.errorCode,
                orderReferenceNumber: paymentReferenceNumber || "",
                errorMessage: getErrorMessage(responseData.errorCode),
              });

              setHideContentTwo(true);
              setShowFailMessage(true);
            }
          } else {
            throw new Error("Failed to update payment status");
          }
        } catch (statusError) {
          console.error("Payment status update failed:", statusError);
          if (invalidCreditCard.length > 0) {
            setHideContentTwo(false);
            setShowFailMessage(false);
          } else {
            setHideContentTwo(true);
            setShowFailMessage(true);
          }
        }
      } else {
        // Payment failed or other status
        setHideContentTwo(true);
        setShowFailMessage(true);
      }
    } catch (error) {
      console.error("Payment error:", error);
      setError(error.message);
      setHideContentTwo(true);
      setShowFailMessage(true);

      const statusResponse = await updatePaymentStatus(paymentReferenceNumber);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <>
        <Card className="bid-deposit-card">
          <Card.Body>
            <p className="bid-deposit-title-info-payment">Payment details</p>
            <Card.Subtitle className="mb-4 bid-deposit-text-info-payment">
              Please enter your credit card details below. Prepaid & debit cards
              will not be accepted.
            </Card.Subtitle>

            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Row className="mb-3 stripe-payment-form">
                <Col md={4}>
                  <Form.Group controlId="firstName" className="my-md-0 my-3">
                    <Form.Label>First Name</Form.Label>
                    <span className="" style={{ color: "#d13b3b" }}>
                      *
                    </span>
                    <Form.Control
                      required
                      type="text"
                      placeholder="First Name"
                      value={formData.firstName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      maxLength={50}
                      isInvalid={!!validationErrors.firstName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {validationErrors.firstName || "This field is required"}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group controlId="lastName">
                    <Form.Label>Last Name</Form.Label>
                    <span className="" style={{ color: "#d13b3b" }}>
                      *
                    </span>
                    <Form.Control
                      required
                      type="text"
                      placeholder="Last Name"
                      maxLength={50}
                      value={formData.lastName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={!!validationErrors.lastName}
                    />
                    <Form.Control.Feedback type="invalid">
                      {validationErrors.lastName || "This field is required"}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3 stripe-payment-form">
                <Col md={4}>
                  <Form.Group controlId="email">
                    <Form.Label>Email</Form.Label>
                    <span className="" style={{ color: "#d13b3b" }}>
                      *
                    </span>
                    <Form.Control
                      required
                      type="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                      disabled
                      readOnly
                      className="bg-light"
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter a valid email address.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group
                    controlId="phone"
                    className="my-md-0 my-3 stripe-payment-form"
                  >
                    <Form.Label>Phone</Form.Label>
                    <span className="" style={{ color: "#d13b3b" }}>
                      *
                    </span>
                    <Form.Control
                      required
                      type="tel"
                      placeholder="Phone"
                      value={formData.phone}
                      maxLength={10}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={!!validationErrors.phone}
                    />
                    <Form.Control.Feedback type="invalid">
                      {validationErrors.phone || "This field is required"}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-3 stripe-payment-form">
                <Col md={8}>
                  {" "}
                  <Form.Group className="mb-3" controlId="address1">
                    <Form.Label>Address</Form.Label>
                    <span className="" style={{ color: "#d13b3b" }}>
                      *
                    </span>
                    <Form.Control
                      required
                      type="text"
                      placeholder="Address"
                      maxLength={200}
                      value={formData.address1}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={!!validationErrors.address1}
                    />
                    <Form.Control.Feedback type="invalid">
                      {validationErrors.address1 || "This field is required"}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3 stripe-payment-form">
                <Col md={3}>
                  <Form.Group controlId="city">
                    <Form.Label>City</Form.Label>
                    <span className="" style={{ color: "#d13b3b" }}>
                      *
                    </span>
                    <Form.Control
                      required
                      type="text"
                      placeholder="City"
                      value={formData.city}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={!!validationErrors.city}
                    />
                    <Form.Control.Feedback type="invalid">
                      {validationErrors.city || "Please enter a city."}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={2}>
                  {" "}
                  <Form.Group controlId="state" className="my-md-0 my-3">
                    <Form.Label>State</Form.Label>
                    <span className="" style={{ color: "#d13b3b" }}>
                      *
                    </span>
                    <Form.Select
                      required
                      value={formData.state}
                      onChange={handleChange}
                      placeholder="State"
                      className="form-select-height-state-bid"
                      onBlur={handleBlur}
                      isInvalid={!!validationErrors.state}
                    >
                      <option value="">Select state</option>
                      {stateList.length > 0 &&
                        stateList?.map((state) => (
                          <option key={state} value={state}>
                            {state}
                          </option>
                        ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {validationErrors.state || "Please select a state."}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group controlId="zip">
                    <Form.Label>Zip</Form.Label>
                    <span className="" style={{ color: "#d13b3b" }}>
                      *
                    </span>
                    <Form.Control
                      required
                      type="text"
                      placeholder="Zip"
                      value={formData.zip}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      maxLength={5}
                      isInvalid={!!validationErrors.zip}
                    />
                    <Form.Control.Feedback type="invalid">
                      {validationErrors.zip ||
                        "Please enter a valid 5-digit zip code."}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              {/* <Row className="mb-3">
                <Col md={6}>
                  <Form.Group controlId="cardNumber">
                    <Form.Label>Card Number</Form.Label>
                    <Form.Control
                      required
                      type="tel"
                      pattern="[0-9]{16}"
                      maxLength="16"
                      placeholder="Enter card number"
                      value={formData.cardNumber}
                      onChange={handleChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter a valid 16-digit card number.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group controlId="expiryDate">
                    <Form.Label>Expiry Date</Form.Label>
                    <Form.Control
                      required
                      type="month"
                      min={new Date().toISOString().slice(0, 7)}
                      value={formData.expiryDate}
                      onChange={handleChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter a valid expiry date.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group controlId="cvv">
                    <Form.Label>CVV</Form.Label>
                    <Form.Control
                      required
                      type="tel"
                      pattern="[0-9]{3,4}"
                      maxLength="4"
                      placeholder="CVV"
                      value={formData.cvv}
                      onChange={handleChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter a valid CVV.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row> */}
              {/* <Form.Group className="mb-3">
                <Form.Label>Card Details</Form.Label>
                <div className="p-3 border rounded">
                  <CardElement
                    options={{
                      style: {
                        base: {
                          fontSize: "16px",
                          color: "#424770",
                          "::placeholder": {
                            color: "#aab7c4",
                          },
                        },
                        invalid: {
                          color: "#9e2146",
                        },
                      },
                      hidePostalCode: true,
                    }}
                  />
                </div>
              </Form.Group> */}
              <Form.Group
                className="mb-3 stripe-payment-form"
                controlId="cardNumber"
              >
                <div className="card-fields-container">
                  <Row>
                    {/* <Col md={6}>
                      <div
                        className={`p-3 border rounded mb-3 ${
                          cardErrors.cardNumber ? "border-danger" : ""
                        }`}
                      >
                        <CardNumberElement
                          options={{
                            style: {
                              base: {
                                fontSize: "16px",
                                color: "#424770",
                                "::placeholder": {
                                  color: "#aab7c4",
                                },
                              },
                              invalid: {
                                color: "#9e2146",
                              },
                            },
                          }}
                          onChange={(event) => {
                            console.log("Card Number Change:", event);

                            if (event.error) {
                              setCardErrors((prev) => ({
                                ...prev,
                                cardNumber: event.error.message,
                              }));
                            } else {
                              setCardErrors((prev) => ({
                                ...prev,
                                cardNumber: "",
                              }));
                            }
                          }}
                        />
                      </div>
                      {cardErrors.cardNumber && (
                        <div className="text-danger small mb-2">
                          {cardErrors.cardNumber}
                        </div>
                      )}
                    </Col> */}
                    <Col md={3}>
                      <Form.Label>Card Details</Form.Label>
                      <span className="" style={{ color: "#d13b3b" }}>
                        *
                      </span>
                      <div
                        className={`p-3 border rounded mb-3 ${
                          cardErrors.cardNumber ? "border-danger" : ""
                        }`}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <div style={{ flexGrow: 1 }}>
                          <CardNumberElement
                            options={{
                              style: {
                                base: {
                                  fontSize: "16px",
                                  color: "#424770",
                                  "::placeholder": {
                                    color: "#aab7c4",
                                  },
                                },
                                invalid: {
                                  color: "#9e2146",
                                },
                              },
                            }}
                            onChange={(event) => {
                              // Add this to track card brand
                              if (event.brand) {
                                setCardBrand(event.brand);
                              }
                              if (event.error) {
                                setCardErrors((prev) => ({
                                  ...prev,
                                  cardNumber: event.error.message,
                                }));
                              } else {
                                setCardErrors((prev) => ({
                                  ...prev,
                                  cardNumber: "",
                                }));
                              }
                            }}
                            onBlur={handleBlur}
                          />
                        </div>
                        {cardBrand && (
                          <div
                            style={{
                              marginLeft: "10px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {getCardBrandIcon(cardBrand)}
                          </div>
                        )}
                      </div>
                      {(cardErrors.cardNumber ||
                        validationErrors.cardNumber) && (
                        <div className="text-danger small mb-2">
                          {cardErrors.cardNumber || "This field is required"}
                        </div>
                      )}
                      {invalidCreditCard && (
                        <div className="text-danger small mb-2">
                          {invalidCreditCard}
                        </div>
                      )}
                    </Col>

                    <Col md={3}>
                      <Form.Label>Expiration Date</Form.Label>
                      <span className="" style={{ color: "#d13b3b" }}>
                        *
                      </span>
                      <div
                        className={`p-3 border rounded mb-3 ${
                          cardErrors.cardExpiry ? "border-danger" : ""
                        }`}
                      >
                        <CardExpiryElement
                          options={{
                            style: {
                              base: {
                                fontSize: "16px",
                                color: "#424770",
                                "::placeholder": {
                                  color: "#aab7c4",
                                },
                              },
                              invalid: {
                                color: "#9e2146",
                              },
                            },
                          }}
                          onChange={(event) => {
                            if (event.error) {
                              setCardErrors((prev) => ({
                                ...prev,
                                cardExpiry: event.error.message,
                              }));
                            } else {
                              setCardErrors((prev) => ({
                                ...prev,
                                cardExpiry: "",
                              }));
                            }
                          }}
                        />
                      </div>
                      {cardErrors.cardExpiry && (
                        <div className="text-danger small mb-2">
                          {cardErrors.cardExpiry}
                        </div>
                      )}
                    </Col>
                    <Col md={2}>
                      <Form.Label>CVV</Form.Label>
                      <span className="" style={{ color: "#d13b3b" }}>
                        *
                      </span>
                      <div
                        className={`p-3 border rounded mb-3 ${
                          cardErrors.cardCvc ? "border-danger" : ""
                        }`}
                      >
                        <CardCvcElement
                          options={{
                            style: {
                              base: {
                                fontSize: "16px",
                                color: "#424770",
                                "::placeholder": {
                                  color: "#aab7c4",
                                },
                              },
                              invalid: {
                                color: "#9e2146",
                              },
                            },
                          }}
                          onChange={(event) => {
                            if (event.error) {
                              setCardErrors((prev) => ({
                                ...prev,
                                cardCvc: event.error.message,
                              }));
                            } else {
                              setCardErrors((prev) => ({
                                ...prev,
                                cardCvc: "",
                              }));
                            }
                          }}
                        />
                      </div>
                      {cardErrors.cardCvc && (
                        <div className="text-danger small mb-2">
                          {cardErrors.cardCvc}
                        </div>
                      )}
                    </Col>
                  </Row>
                </div>
              </Form.Group>

              {/* {error && <div className="alert alert-danger mb-3">{error}</div>} */}
              <Button
                type="submit"
                disabled={isLoading}
                size="lg"
                className="biddeposit_button"
                style={{ marginBottom: "15px" }}
              >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Processing...
                  </>
                ) : (
                  "Pay"
                )}
              </Button>
              {isLoading && (
                <>
                  <ShimmerText line={5} gap={10} />
                </>
              )}
              <hr />
            </Form>
            <span className="bid-deposit-checkbox-label">
              {!paymentFlag && (
                <span className="bid-deposit-authorization-text">
                  Please note that you'll see two separate transactions on your
                  credit card from Altisource Online Auction, Inc., a bid
                  deposit hold of $
                  {formatedAmount === "0.00"
                    ? selectorFormatedAmount
                    : formatedAmount}{" "}
                  and a one-time, non-refundable $
                  {formatedChargeAmount === "0.00"
                    ? selectorFormatedChargeAmount
                    : formatedChargeAmount}{" "}
                  charge.
                </span>
              )}
            </span>
            <span className="bid-deposit-terms-text ">
              By submitting this bid deposit I understand that if I am the
              selected bidder and I fail to return any required contracts or
              send the required earnest money or sale deposit within the
              applicable time frame set forth in the communications or legal
              documents, the bid deposit hold amount will be converted to a
              non-refundable charge on my credit card.
            </span>
          </Card.Body>
        </Card>
      </>
    </>
  );
};

export default BidForm;

// Add this function to handle card number formatting
// const formatCardNumber = (value) => {
//   // Remove any non-digit characters
//   const digits = value.replace(/\D/g, '');
//   // Add space after every 4 digits
//   const formatted = digits.replace(/(\d{4})(?=\d)/g, '$1 ');
//   return formatted;
// };

// Add this to your component's functions
// const handleCardNumberChange = (e) => {
//   let value = e.target.value;
//   // Format the value with spaces
//   const formatted = formatCardNumber(value);
//   // Update form data with the formatted value
//   setFormData(prev => ({
//     ...prev,
//     cardNumber: formatted
//   }));
// };

// Update the card number input field
{
  /* <Form.Group controlId="cardNumber">
  <Form.Label>Card Number</Form.Label>
  <Form.Control
    required
    type="text" // Changed from 'tel' to 'text'
    maxLength="19" // 16 digits + 3 spaces
    placeholder="xxxx xxxx xxxx xxxx"
    value={formData.cardNumber}
    onChange={handleCardNumberChange}
    pattern="[\d\s]{19}" // Allow digits and spaces
  />
  <Form.Control.Feedback type="invalid">
    Please enter a valid 16-digit card number.
  </Form.Control.Feedback>
</Form.Group> */
}

// When submitting the form, you'll need to remove spaces
// const handleSubmit = (event) => {
//   event.preventDefault();
//   const form = event.currentTarget;

//   // Remove spaces from card number before validation
//   const cardNumberWithoutSpaces = formData.cardNumber.replace(/\s/g, '');

//   if (form.checkValidity() === false || cardNumberWithoutSpaces.length !== 16) {
//     event.stopPropagation();
//   } else {
//     setLoading(true);
//     // Use cardNumberWithoutSpaces when sending to server
//     const submitData = {
//       ...formData,
//       cardNumber: cardNumberWithoutSpaces
//     };
//     // Process form submission
//     setHideContentTwo(true);
//     setShowMessage(true);
//   }
//   setValidated(true);
// };

// TODO:

// Create a new PaymentIntent
// Backend code
// !const stripe = require('stripe')(process.env.STRIPE_SECRET_KEY);

//! app.post('/create-payment-intent', async (req, res) => {
//! try {
//!   const paymentIntent = await stripe.paymentIntents.create({
//!    amount: 100000, // amount in cents
//!   currency: 'usd',
//!  description: 'Hubzu Bid Deposit',
//!  capture_method: 'manual',
//! setup_future_usage: 'off_session',
//! payment_method_types: ['card']
//!  });

//!   res.json({
//!     clientSecret: paymentIntent.client_secret
//!  });
//! } catch (error) {
//! res.status(500).json({ error: error.message });
//! }
//!});
